import parsePhoneNumberFromString from 'libphonenumber-js/mobile';
import { API } from '@/api/API';
export function isValidUsPhoneNumber(phoneNumber) {
    if (!phoneNumber)
        return false;
    const parsed = parsePhoneNumberFromString(phoneNumber);
    return !!parsed && parsed.isValid() && parsed.country === 'US';
}
export function checkSmsAvailability(phoneNumber) {
    const body = { sms_to: phoneNumber };
    return API.post('sms/outbound/available', { body }).then((response) => {
        const status = response.sms_status._data[0];
        if (!status) {
            return { smsAvailable: false };
        }
        return {
            smsAvailable: status.sms_available,
            countryCode: status.country_code,
        };
    });
}
